// extracted by mini-css-extract-plugin
export default {"crop":"area-selection_crop__W-SD6"};